import { IEvent, IHost } from "@Interfaces";
import { getEventHeaderTitle } from "@Modules/eventPage/utils/getEventHeaderTitle";
import { isEmpty, pluralise } from "@Utils";
import { getPlanData } from "@Modules/eventPage/utils/plan";
import { checkIsEmptyHtmlString } from "repoV2/utils/common/validators/validators";
import { IAboutEvent } from "./IAboutEvent";
import { getHideAboutPlan } from "../AboutPlan/getHideAboutPlan";

export const getAboutEventProps = ({
    planId,
    eventData,
    host,
}: {
    planId?: string;
    eventData: IEvent.IEventData;
    host: IHost.IStore;
}): IAboutEvent.IProps => {
    const planData = getPlanData({
        host,
        planId,
    });
    const hideAboutPlan = getHideAboutPlan({ planId });

    const descMaxLength = 500;
    const reviewCount = eventData.reviews?.length || 0;
    const eventDescription = eventData?.description || "";
    const hideEventDescription = checkIsEmptyHtmlString(eventDescription);
    let aboutEventHeader = `About the ${getEventHeaderTitle({ eventData })}`;
    let offeringIsRecommended = false;

    // in case of plan, About event header will be offering title with Recommended tag(if Recommended)
    if (!isEmpty(planData)) {
        const { listings = [] } = planData || {};
        const selected_listing = listings.find(
            value => value?.plan_listing_map_uuid === eventData?.uuid
        );
        const show_recommended_tag = planData?.metadata?.show_recommended_tag;

        const { is_recommended, title } = selected_listing || {};

        if (!isEmpty(title)) {
            aboutEventHeader = title ?? aboutEventHeader;
            offeringIsRecommended = !!show_recommended_tag && !!is_recommended;
        }
    }

    return {
        hideComponent: hideEventDescription || !hideAboutPlan,
        minifyEventDescription:
            eventData?.metadata?.event_desc_minify_length ?? true, // true if not defined
        descMaxLength,
        creatorStats: [
            {
                count: reviewCount,
                text: pluralise("Review", reviewCount),
            },
            { count: eventData?.rating, text: "Rating" },
        ],
        hideAboutEventHeader: eventData?.metadata?.hide_about_header,
        aboutEventHeader,
        hideEventDescription,
        eventDescription,
        offeringIsRecommended,
    };
};
